<template>
  <el-tabs type="border-card">
    <el-tab-pane label="代办发货列表">
      <div>
        <vm-table
            ref="vmTable"
            height="64vh"
            :filter.sync="filter"
            module="basic"
            url="replacementBills/deliveryMaterial"
            @select="select">
          <div slot="toolbar">
            <el-button type="primary" @click="deliverExport()">发货单打印/导出</el-button>
            <el-button type="primary" :loading="exportLoading" @click="exportExcel()">导出</el-button>
          </div>
          <template slot="adSearch">
            <vm-search label="发运日期">
              <div class="block">
                <el-date-picker
                    v-model="filter.beginDeliveryDate"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="date"
                    style="width: 190px"
                    placeholder="选择开始日期"/>
              </div>
            </vm-search>
            <vm-search label="至">
              <div class="block">
                <el-date-picker
                    v-model="filter.endDeliveryDate"
                    value-format="yyyy-MM-dd 23:59:59"
                    type="date"
                    style="width: 190px"
                    placeholder="选择结束日期"/>
              </div>
            </vm-search>
            <vm-search label="状态">
              <el-select v-model="filter.status" clearable>
                <el-option label="待处理" :value="10"/>
                <el-option label="已完成" :value="90"/>
              </el-select>
            </vm-search>
            <vm-search label="关键字">
              <el-input v-model.trim="filter.filter" clearable/>
            </vm-search>
            <vm-search label="是否打印">
              <el-select v-model="filter.isPrint" clearable>
                <el-option label="未打印" :value="0"/>
                <el-option label="已打印" :value="1"/>
              </el-select>
            </vm-search>
          </template>
          <el-table-column type="selection" align="center" width="40"/>
          <el-table-column
              fixed="left"
              prop="billNo"
              width="100"
              align="center"
              label="单号">
            <template slot-scope="scope">
              <div style="color: #2d8cf0; cursor: pointer" @click="goto(scope.row)">{{scope.row.billNo}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="submitTime" width="135" align="center" label="提交时间"/>
          <el-table-column prop="materialNo" label="SAP物料代码" align="center" width="100"/>
          <el-table-column prop="materialDesc" label="名称/型号/规格" align="center" width="180"/>
          <el-table-column prop="quantity" label="数量" width="45" align="center"/>
          <el-table-column prop="deliveryWay" label="发运方式" width="80" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.deliveryWay" size="mini"/>
            </template>
          </el-table-column>
          <el-table-column prop="deliveryBillNo" label="发运单号" align="center" width="155">
            <template slot-scope="scope">
              <el-input v-model="scope.row.deliveryBillNo" size="mini"/>
            </template>
          </el-table-column>
          <el-table-column prop="deliveryDate" label="发运日期" align="center" width="160">
            <template slot-scope="scope">
              <el-date-picker
                  v-model="scope.row.deliveryDate"
                  size="mini"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期"
                  style="width:auto"/>
            </template>
          </el-table-column>
          <el-table-column prop="deliveryBillNo" label="发运备注" width="150" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.deliveryNote" type="textarea" size="mini"/>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="150">
            <template slot-scope="scope">
              <el-button
                  size="mini"
                  style="border-radius: 4px"
                  :loading="submitLoading"
                  type="primary"
                  @click="saveModel(scope.row)">
                保存
              </el-button>
              <el-button
                  size="mini"
                  style="border-radius: 4px"
                  :loading="submitLoading"
                  type="success"
                  @click="confirmDelivery(scope.row)">
                确认发运
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="serialNo" width="120" align="center" label="发出-序列号">
            <template slot-scope="scope">
              <el-input v-model="scope.row.serialNo" placeholder="请输入"/>
            </template>
          </el-table-column>
        </vm-table>
      </div>
    </el-tab-pane>
    <el-tab-pane label="待复审列表">
      <div>
        <vm-table
            ref="vmTable2"
            height="64vh"
            :filter.sync="filter2"
            module="basic"
            url="replacementBills/getRevisionList"
            @select="select">
          <div slot="toolbar">
            <el-button type="primary" @click="deliverExport()">发货单打印/导出</el-button>
          </div>
          <template slot="adSearch">
            <vm-search label="关键字">
              <el-input v-model.trim="filter.filter" clearable/>
            </vm-search>
          </template>
          <el-table-column type="selection" align="center" width="55"/>
          <el-table-column
              fixed="left"
              prop="billNo"
              width="120"
              align="center"
              label="单号">
            <template slot-scope="scope">
              <div style="color: #2d8cf0; cursor: pointer" @click="goto(scope.row)">{{scope.row.billNo}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="materialNo" label="SAP物料代码" align="center" width="130"/>
          <el-table-column prop="materialDesc" label="名称/型号/规格" align="center" width="350"/>
          <el-table-column prop="quantity" label="数量" width="60" align="center"/>
          <el-table-column prop="deliveryDate" label="发运日期" align="center" width="200">
            <template slot-scope="scope">
              <el-date-picker
                  v-model="scope.row.deliveryDate"
                  size="mini"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期"
                  style="width:auto"/>
            </template>
          </el-table-column>
          <el-table-column prop="deliveryWay" label="发运方式" width="90" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.deliveryWay" size="mini"/>
            </template>
          </el-table-column>
          <el-table-column prop="deliveryBillNo" label="发运单号" align="center" width="180">
            <template slot-scope="scope">
              <el-input v-model="scope.row.deliveryBillNo" size="mini"/>
            </template>
          </el-table-column>
          <el-table-column prop="deliveryNote" label="发运备注" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.deliveryNote" size="mini"/>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="150">
            <template slot-scope="scope">
              <el-button
                  size="mini"
                  style="border-radius: 4px"
                  :loading="submitLoading"
                  type="primary"
                  @click="saveModel(scope.row)">
                保存
              </el-button>
            </template>
          </el-table-column>
        </vm-table>
      </div>
    </el-tab-pane>
    <replacement-edit ref="editPage" @save-success="getList(1)"/>
    <delivery-bill-code-print ref="deliveryCodePrint"/>
  </el-tabs>
</template>



<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import ReplacementEdit from "@/views/afterSalesManagement/Replacement/ReplacementEdit";
  import DeliveryBillPrintOther from "@/views/afterSalesManagement/Replacement/DeliveryBillPrintOther";
  import DeliveryBillCodePrint from "@/views/afterSalesManagement/Replacement/DeliveryBillCodePrint";
  export default {
    name: "",
    components: {DeliveryBillCodePrint, ReplacementEdit, VmTable,VmSearch},
    data() {
      return {
        selectionList: "",
        exportLoading: false,
        submitLoading: false,
        filter: {
          filter: "",
          deliveryDate: "",
          beginDeliveryDate: "",
          endDeliveryDate: "",
          isPrint: "",
          status: 10,
        },
        filter2: {
          filter: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
      this.$refs.vmTable2.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      getList2(pageNum) {
        this.$refs.vmTable2.getList(pageNum);
      },
      select(selection) {
        this.selectionList = selection;
      },
      saveModel(row) {
        this.submitLoading = true;
        this.$http
          .put("basic","replacementBills/confirmDelivery/0", row,"false")
          .then(() => {
            this.submitLoading = false;
            this.dialogVisible = false;
            this.getList(1);
            this.$message.success("保存成功");
          })
          .catch(() => {
            this.submitLoading = false;
          });
      },
      confirmDelivery(row) {
        if (!row.deliveryDate) {
          this.$message.error("请填写发运日期");
          return;
        }
        if (!row.deliveryBillNo) {
          this.$message.error("请填写发运单号");
          return;
        }
        this.submitLoading = true;
        this.$http
          .put("basic","replacementBills/confirmDelivery/1", row)
          .then(() => {
            this.submitLoading = false;
            this.dialogVisible = false;
            this.getList(1);
            this.$message.success("确认成功");
          })
          .catch(() => {
            this.submitLoading = false;
          });
        
        
      },
      goto(row) {
        this.$router.push({
          path: "/Replacement",
          query: {
            billType: 13,
            billId: row.masterId,
            $tabName: row.billNo,
          },
        });
      },
      deliverExport() {
        console.log(this.selectionList);
        if (this.selectionList.length===1) {
          this.$http
            .get("basic", `replacementBills/${this.selectionList[0].masterId}`)
            .then(resp => {
              this.$refs.deliveryCodePrint.open(resp);
            });
        } else {
          this.$message.error("请选择一个要打印的项目");
        }
      },
      //导出
      exportExcel() {
        this.exportLoading = true;
        console.log(this.filter);
        this.$http
          .exportFile("basic","replacementBills/deliveryPrint", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>

<style scoped>

</style>
